import environment from "../../environment/environment";
const BASE_URL = `${environment.API}`;

export function getTokenClient(data, issuePolicy, clientToken) {
  braintree.client.create(
    {
      authorization: clientToken,
    },
    function (clientErr, clientInstance) {
      if (clientErr) {
        alert("Error creating client:");
        return;
      }
      let deviceData;

      braintree.dataCollector.create(
        {
          client: clientInstance,
        },
        function (dataCollectorErr, dataCollectorInstance) {
          if (dataCollectorErr) {
            console.error("Error creating dataCollectorInstance:", dataCollectorErr);
            return;
          }
          deviceData = dataCollectorInstance.deviceData;
        }
      );

      braintree.applePay.create(
        {
          client: clientInstance,
        },
        function (applePayErr, applePayInstance) {
          if (applePayErr) {
            alert("Error creating applePayInstance:");
            return;
          }

          var paymentRequest = applePayInstance.createPaymentRequest({
            total: {
              label: "Sanborn's Mexico Auto Insurance",
              amount: data.coverages.total,
            },
            requiredBillingContactFields: ["postalAddress"],
          });

          var session = new ApplePaySession(3, paymentRequest);

          session.onvalidatemerchant = function (event) {
            applePayInstance.performValidation(
              {
                validationURL: event.validationURL,
                displayName: "Sanborn's Mexico Auto Insurance",
              },
              function (err, merchantSession) {
                if (err) {
                  // You should show an error to the user, e.g. 'Apple Pay failed to load.'
                  alert("Apple Pay failed to load");
                  return;
                }
                session.completeMerchantValidation(merchantSession);
              }
            );
          };

          session.onpaymentauthorized = function (event) {
            applePayInstance.tokenize(
              {
                token: event.payment.token,
              },
              async function (tokenizeErr, payload) {
                if (tokenizeErr) {
                  alert("Error tokenizing Apple Pay:");
                  session.completePayment(ApplePaySession.STATUS_FAILURE);
                  return;
                }

                // If requested, address information is accessible in event.payment
                // and may also be sent to your server.

                payload.deviceData = deviceData;

                // After you have transacted with the payload.nonce,
                // call 'completePayment' to dismiss the Apple Pay sheet.
                session.completePayment(ApplePaySession.STATUS_SUCCESS);
                issuePolicy(payload);
              }
            );
          };

          session.begin();
        }
      );
    }
  );
}
